import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserDetails } from '../user-details.model';
import { UserService } from '../user.service';
import 'rxjs/add/operator/first';
import { CrawfordPageHeaderService, PageHeaderMenuItem, CrawfordSnackbarService, CrawfordDownloadService } from 'crawford-shell';

@Injectable()
export class UserDetailsResolver implements Resolve<UserDetails> {
  constructor (
    private userService: UserService,
    private pageHeaderService: CrawfordPageHeaderService,
    private snackbarService: CrawfordSnackbarService,
    private downloadService: CrawfordDownloadService,
    private router: Router
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserDetails> {
    console.debug('DEBUG INFO: UserDetailsResolver.resolve() - Called');

    return this.userService.subscribeToUserDetails().map(userDetails => {
      if (userDetails) {
        console.debug('DEBUG INFO: UserDetailsResolver.resolve() - User details found');
        this.setHeaderMenu(userDetails);
        return userDetails;
      } else {
        console.error('DEBUG INFO: UserDetailsResolver.resolve() - No user details found');
        this.router.navigate(['/']);
        return null;
      }
    }).first();
  }

  private setHeaderMenu(userDetails: UserDetails): void {
    const userOptionsItem: PageHeaderMenuItem = {
      icon: 'fa fa-fw fa-user-circle',
      title: 'User Options',
      index: 1
    };

    const userNameItem: PageHeaderMenuItem = {
      icon: 'fa fa-fw fa-user',
      title: userDetails.userName,
      index: 0
    };

    const savedSearchesItem: PageHeaderMenuItem = {
      icon: 'fa fa-fw fa-search',
      title: 'My Saved Searches',
      index: 1,
      route: ['claim/search/retrieve-search']
    };

    const logoutItem: PageHeaderMenuItem = {
      icon: 'fa fa-fw fa-sign-out',
      title: 'Log Out',
      index: 3,
      callback: () => {
        this.userService.logout().subscribe();
      }
    };

    if (userDetails.userType === 'External') {
      this.addUserGuideItem();
      userOptionsItem.children = [ userNameItem, savedSearchesItem, logoutItem ];
    } else {
      userOptionsItem.children = [ userNameItem, savedSearchesItem ];
    }

    this.pageHeaderService.addMenuItem(userOptionsItem);
  }

  private addUserGuideItem(): void {
    const userGuideItem: PageHeaderMenuItem = {
      icon: 'fa fa-fw fa-question-circle',
      title: 'User Guide',
      index: 0,
      callback: () => {
        this.snackbarService.displayInfoMessage('Downloading user guide...');

        this.userService.getUserGuide().subscribe(
          response => {
            if (response) {
              this.downloadService.downloadFileFromResponse(response);
            } else {
              this.snackbarService.displayErrorMessage('Unable to download user guide');
            }
          }
        );
      }
    };

    this.pageHeaderService.addMenuItem(userGuideItem);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/user/resolvers/user-details.resolver.ts